<template>
  <app-card design="new" padding="none" class="app-filter-toolbar-card">
    <div class="app-filter-toolbar" :class="{ 'app-filter-toolbar--without-actions': !$slots.actions }">
      <div class="app-filter-toolbar__controls" :class="{ 'app-filter-toolbar__controls--start': controlsAlign === 'start' }">
        <div v-if="$slots.create" class="app-filter-toolbar__create"><slot name="create" /></div>
        <div v-if="$slots.primary" class="app-filter-toolbar__primary"><slot name="primary" /></div>
        <div class="app-filter-toolbar__fields"><slot /></div>
        <div v-if="$slots.selection" class="app-filter-toolbar__selection"><slot name="selection" /></div>
        <div v-if="$slots['secondary-selection']" class="app-filter-toolbar__selection"><slot name="secondary-selection" /></div>
        <div v-if="$slots['tertiary-selection']" class="app-filter-toolbar__selection app-filter-toolbar__selection--wrapping"><slot name="tertiary-selection" /></div>
      </div>
      <div v-if="$slots.actions" class="app-filter-toolbar__actions"><slot name="actions" /></div>
      <div v-if="$slots.clear" class="app-filter-toolbar__clear"><slot name="clear" /></div>
    </div>
  </app-card>
</template>

<script>
import AppCard from './AppCard.vue'

export default {
  name: 'AppFilterToolbar',
  components: { AppCard },
  props: {
    controlsAlign: { type: String, default: 'center', validator: value => ['center', 'start'].includes(value) }
  }
}
</script>

<style lang="scss" scoped>
.app-filter-toolbar-card { position: relative; z-index: 40; flex: 0 0 auto; }

.app-filter-toolbar {
  position: relative;
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: start;
  gap: $ui-space-12 $ui-space-16;
  padding: $ui-space-12 $ui-space-16;
  color: $ui-text;
  font-family: $ui-font-body;

  &--without-actions { grid-template-columns: minmax(0, 1fr); }

  &__controls { display: flex; align-items: center; flex-wrap: wrap; min-width: 0; gap: $ui-space-12; }
  &__controls--start { align-items: flex-start; }
  &__create { display: flex; flex: 0 0 auto; align-items: center; flex-wrap: wrap; gap: $ui-space-12; }
  &__primary { flex: 0 0 $ui-filter-control-width; width: $ui-filter-control-width; min-width: 0; max-width: 100%; }
  &__fields {
    display: contents;
    :deep(.select), :deep(.ui-date-field), :deep(.datepicker) { flex: 0 0 $ui-filter-control-width; width: $ui-filter-control-width; min-width: 0; max-width: 100%; }
  }
  &__selection { flex: 0 1 auto; max-width: 100%; min-width: 0; overflow-x: auto; }
  &__selection--wrapping { flex: 1 1 ($ui-filter-control-width * 3); overflow: visible; }
  &__actions { display: flex; min-height: $ui-control-height; justify-content: flex-end; align-items: center; gap: $ui-space-12; }
  &__clear { position: absolute; top: -$ui-space-12; right: -$ui-space-12; z-index: 20; }
}

@media (max-width: 760px) {
  .app-filter-toolbar { grid-template-columns: minmax(0, 1fr); }
}
</style>
